import { Serializable } from '@/models/core/serializable';

export class SchoolSetting implements Serializable<SchoolSetting> {
  companyID: number;
  twoFactorAuth: boolean;
  deserialize(input: any): SchoolSetting {
    // 学校ID
    this.companyID = input.companyID;
    // 2要素認証 ON / OFF
    this.twoFactorAuth = input.twoFactorAuth;
    return this;
  }
}
